export default [
    {
        path: 'plantao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-plantao' */
            '@/views/pronto-atendimento/plantao/Index'
        ),
        redirect: 'plantao/index',
        children: [
            {
                name: 'pronto-atendimento-plantao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-plantao' */
                    '@/views/pronto-atendimento/plantao/List.vue'
                ),
            },
        ],
    },
]